module.exports = __webpack_public_path__ + "static/CA-0bc06077b9701a559a0051d55ea695cb.svg";